module.exports = __webpack_public_path__ + "static/media/www.restaurantporssi.fi.fd62fdb9.png";